import { FiArrowUpRight } from 'react-icons/fi'
import { cn } from '@/lib/cn'

interface CircleBadgeProps {
  /** Text that runs once around the circle. A separating dot is added automatically. */
  text?: string
  className?: string
  /** Tailwind text-color class for the rotating label, e.g. "text-white". */
  textClassName?: string
  /** Tailwind color class for the centre arrow, e.g. "text-ibon-sky". */
  arrowClassName?: string
}

/**
 * Slowly-rotating circular text badge with a static arrow in the centre.
 * the spinning disc used throughout the guide.
 */
export const CircleBadge = ({
  text = 'IBON WORLD • AFRICA & CARIBBEAN • ',
  className,
  textClassName = 'fill-current text-ibon-dark',
  arrowClassName = 'text-ibon-sky',
}: CircleBadgeProps) => {
  return (
    <div className={cn('relative grid h-32 w-32 place-items-center', className)}>
      <svg viewBox="0 0 100 100" className="absolute inset-0 h-full w-full animate-spin-slow">
        <defs>
          <path id="circle-badge-path" d="M 50,50 m -37,0 a 37,37 0 1,1 74,0 a 37,37 0 1,1 -74,0" />
        </defs>
        <text className={cn('text-[8px] font-semibold uppercase tracking-[0.08em]', textClassName)}>
          <textPath href="#circle-badge-path" startOffset="0">
            {text}
          </textPath>
        </text>
      </svg>
      <FiArrowUpRight className={cn('relative', arrowClassName)} size={26} />
    </div>
  )
}
